import React, {createContext, useReducer} from 'react'

export const SET_USAGE_REPORT_LIST = 'SET_USAGE_REPORT_LIST'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_USAGE_REPORT_LIST:
      return { ...data, list: payload.data }
    default:
      return data
  }
}

const initialState = {
  list: [],
}

const UsageReportStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <UsageReportContext.Provider value={[state, dispatch]}>
      {children}
    </UsageReportContext.Provider>
  )
}

export const UsageReportContext = createContext(initialState)
export default UsageReportStore
